import React from 'react';

import { Link } from 'react-router-dom';

import { useLogo } from '../../logoContext';

import forwardIcon from '../../asset/images/icons/forward-icon.svg';
import strip from '../../asset/images/pattern-cropped.svg'
import icon from '../../asset/images/footer-icon.png'

import plane from '../../asset/images/plane-icon.svg';
import greenPlane from '../../asset/images/green-plane.svg'

import saudi from '../../asset/images/airlines/saudi-logo.png'
import emirates from '../../asset/images/airlines/emirates.png'
import british from '../../asset/images/airlines/british.png'
import qatar from '../../asset/images/airlines/qatar-airways.png'
import etihad from '../../asset/images/airlines/etihad.png'

import ticketIcon from '../../asset/images/ticket-icon.png'

import { useQuery } from 'react-query';
import { useGuestStore } from '../../App';
import axios from 'axios';

import { formatDate } from '../../utils/formatDate'

import IP from '../../sections/variables'
import HeaderComponent from 'src/components/header.component';
import airplaneIcon from '../../asset/images/new/airplane.png'
import calendarIcon from '../../asset/images/new/calendar.png'
import clockIcon from '../../asset/images/new/clock.png'
import lockIcon from '../../asset/images/new/lock.png'
import careerIcon from "../../asset/images/icons/bag.png";

import LogOutComponent from 'src/components/logout.component';

const FlightDetailsPage = () => {

  document.title = 'Flight Details | SNB';

  const logoSrc = useLogo();

  const userID = useGuestStore((state) => state.id)

  const URL = `${window.location.protocol}//${IP}/api`

  const {
    isLoading,
    isError,
    error,
    refetch,
    data,
    isSuccess
  } = useQuery(`userID-${userID}`, async () => axios.get(`${URL}/guests/flight/${userID}`))


  const guestName = data?.data?.guest
  const arrivalFlight = data?.data?.arr_flight ?? {}
  const depFlight = data?.data?.dep_flight ?? {}

  return (
    <div className="home-wrapper app-wrapper">
      <div className="gradient-card">
        <div className='page-content'>
          <HeaderComponent showBack={true} />

          <div className="container custom-container-sm">
            <div className='flight-header-wrapper mt-5'>
              <div className="d-flex">
                <img className='header-plane-icon' src={airplaneIcon} alt="" />
                {/* <h4 className='ms-3'>{depFlight?.from_location ? depFlight?.from_location : 'N/A'}</h4>
                <h4 className='px-2'> to </h4>
                <h4>{depFlight?.to_location ? depFlight?.to_location : 'N/A'}</h4> */}
              </div>
              <div className="flight-header">
                <span style={{ minWidth: "100px" }}></span>
                <p className='boarding-card-header text-white mb-0 pe-3' style={{ letterSpacing: "1px" }}>Your Flight to Washington DC  Meeting Oct. 2025</p>
              </div>

            </div>
            <div className="flight-details-wrapper">
              <div className="flight-details">
                <h6 className='mb-1'>Guest Name</h6>
                <h4>{guestName ? guestName : 'N/A'}</h4>
              </div>
              <div className="row">
                <div className="col-6 mb-3">
                  <div className="flight-detail-cards">
                    <div className="d-flex align-items-center">
                      <img src={calendarIcon} className='home-icon mb-0' alt="" />
                      <div className='d-flex flex-wrap ms-3'>
                        <h6 className='mb-0 me-2'>From:</h6>
                        <h4 className="mb-0">{depFlight?.from_location ? depFlight.from_location : 'N/A'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="flight-detail-cards">
                    <div className="d-flex align-items-center">
                      <img src={careerIcon} className='home-icon mb-0' alt="" />
                      <div className='d-flex flex-wrap ms-3'>
                        <h6 className='mb-0 me-2'>Carier:</h6>
                        <h4 className="mb-0">{depFlight?.carrier ? depFlight.carrier : 'N/A'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="flight-detail-cards">
                    <div className="d-flex align-items-center">
                      <img src={calendarIcon} className='home-icon mb-0' alt="" />
                      <div className='d-flex flex-wrap ms-3'>
                        <h6 className='mb-0 me-2'>To:</h6>
                        <h4 className="mb-0">{depFlight?.to_location ? depFlight.to_location : 'N/A'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="flight-detail-cards">
                    <div className="d-flex align-items-center">
                      <img className='header-plane-icon' src={airplaneIcon} alt="" />
                      <div className='d-flex flex-wrap ms-3'>
                        <h6 className='mb-0 me-2'>Flight No.:</h6>
                        <h4 className="mb-0">{depFlight?.flight_number ? depFlight.flight_number : 'N/A'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="flight-detail-cards">
                    <div className="d-flex align-items-center">
                      <img src={clockIcon} className='home-icon' alt="" />
                      <div className='d-flex flex-wrap ms-3 mb-2'>
                        <h6 className='mb-0 me-2'>Departure:</h6>
                        <h4 className="mb-0">{depFlight?.formatted_time ? depFlight?.formatted_time : 'N/A'}</h4>
                      </div>
                    </div>

                    <div className="d-flex align-items-center">
                      <img src={calendarIcon} className='home-icon mb-0' alt="" />
                      <div className='d-flex flex-wrap ms-3'>
                        <h6 className='mb-0 me-2'>Date:</h6>
                        <h4 className="mb-0">{depFlight?.date ? formatDate(depFlight.date) : 'N/A'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <LogOutComponent />
      </div>

    </div >
  );
};

export default FlightDetailsPage;


